

























import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import BaseModal from '~/components/modals/BaseModal.vue';
import RouteTimesItem from '~/components/lists/items/RouteTimesItem.vue';

@Component({
  components: { BaseModal, RouteTimesItem },
})
export default class RouteTimesModal extends Vue {
  @Prop(Array) times: [];

  /* Emits a close event to the parent to close modal */
  @Emit('modal-close')
  close () {}
};
